var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTextareaAutoResize } from '@loop/comm-display-util-dom';
import { FieldContainer, InputError, Label } from './field';
import { TextArea } from './global.styles';
const MAX_INPUT_ROWS = 5;
const MAX_INPUT_HEIGHT = 24 * (MAX_INPUT_ROWS - 1) + 37;
export const TextareaField = React.forwardRef((_a, forwardedRef) => {
    var { name, label, fieldError } = _a, rest = __rest(_a, ["name", "label", "fieldError"]);
    const ref = rest.autoResize
        ? useTextareaAutoResize({ text: rest.value, maxHeight: MAX_INPUT_HEIGHT })
        : forwardedRef;
    return (React.createElement(FieldContainer, null,
        label && React.createElement(Label, { htmlFor: name }, label),
        React.createElement(TextArea, Object.assign({}, rest, { id: name, name: name, rows: 1, ref: ref })),
        fieldError && React.createElement(InputError, null, fieldError)));
});
//# sourceMappingURL=textarea-field.js.map